// UI strings for the prompt under an unsure translator answer (app/src/translator/panels/SaveHelp.tsx):
// save the right translation as your own, and fix the words (own-word need or proposal, a mark).
// Finnish (default) and English side by side; en must have exactly the same shape.
import { defineArea } from '../area';

type Lang = 'hv' | 'fi' | 'en';

export const saveHelpFi = {
  head: 'Tiedätkö oikean käännöksen?',
  open: 'Tallenna se',
  label: { hv: 'Oikea käännös valyriaksi', fi: 'Oikea käännös suomeksi', en: 'Oikea käännös englanniksi' } as Record<Lang, string>,
  hintHv: 'Valyriankielinen käännös on oma ehdotuksesi, ei virallinen. Kun se on tarkistettu ja hyväksytty, kääntäjä käyttää sitä.',
  hint: 'Kun se on tarkistettu ja hyväksytty, kääntäjä käyttää sitä.',
  save: 'Tallenna',
  empty: 'Kirjoita käännös ensin.',
  saved: 'Tallennettu tarkistusjonoon.',
  savedOffline: 'Tallennettu. Se lähtee tarkistusjonoon, kun yhteys palaa.',
  wordsLabel: 'Sanat',
  addWord: 'Lisää sana',
  needDone: 'Pyydetty omiin sanoihin',
  meaning: { fi: 'Mitä sana tarkoittaa suomeksi?', en: 'Mitä sana tarkoittaa englanniksi?' } as Record<'fi' | 'en', string>,
  meaningHint: 'Merkitys on oma arviosi. Sana tulee sanakirjaan, kun toinen teistä hyväksyy sen Omissa sanoissa.',
  saveWord: 'Tallenna sana',
  wordDone: 'Ehdotettu omiin sanoihin',
  wrongSense: 'Väärä merkitys?',
  failed: 'Tallennus ei onnistunut. Yritä uudelleen.',
};

const saveHelpEn: typeof saveHelpFi = {
  head: 'Do you know the right translation?',
  open: 'Save it',
  label: { hv: 'The right translation in High Valyrian', fi: 'The right translation in Finnish', en: 'The right translation in English' },
  hintHv: 'The High Valyrian is your own suggestion, not an official translation. Once it is reviewed and approved, the translator uses it.',
  hint: 'Once it is reviewed and approved, the translator uses it.',
  save: 'Save',
  empty: 'Write the translation first.',
  saved: 'Saved to the review queue.',
  savedOffline: 'Saved. It goes to the review queue when you are back online.',
  wordsLabel: 'Words',
  addWord: 'Add the word',
  needDone: 'Requested for your own words',
  meaning: { fi: 'What does the word mean in Finnish?', en: 'What does the word mean in English?' },
  meaningHint: 'The meaning is your own guess. The word enters the dictionary once the other of you approves it in Own words.',
  saveWord: 'Save the word',
  wordDone: 'Proposed for your own words',
  wrongSense: 'Wrong meaning?',
  failed: 'Could not save. Try again.',
};

// Messages.saveHelp (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('saveHelp', saveHelpFi, saveHelpEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof saveHelpFi> {}
}
